import React, { useEffect, useState } from 'react';
import { 
  setBasicInfo,
  getBasicInfo,
  getSessionStorageItem,
  setSessionStorageItem,
  SESSION_STORAGE_ACCOUNT_KEY,
  SESSION_STORAGE_EMAIL_CAPTURE, 
  SESSION_STORAGE_SAVED_QUOTE_DATA
} from '../../../../../sessionStorage';
import AboutData from './AboutData';
import MarketingData from './MarketingData';
import Supplemental from '../../../../Quoters/Supplemental/Supplemental';
import PurchasingProcessData from './PurchasingProcessData';
import SaveQuotePartnerReferral from '../../../../Quoters/CustomizeTerm/SaveTermQuotePartnerReferral/SaveQuotePartnerReferral';

export default function SuppData(props) {
  const minAge = 18;
  const maxAge = 64;

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const emailCapture = getSessionStorageItem(SESSION_STORAGE_EMAIL_CAPTURE);
  const savedQuote = getSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA);
  const basicInfo = getBasicInfo();

  const [isQuoteSaved, setQuoteSaved] = useState(savedQuote.quoteSaved);
  const [errorMessage, setErrorMessage] = useState({ message: '', status: '' });
  const [saveQuoteData, setSaveQuoteData] = useState(null);
  const [saveQuoteContact, setSaveQuoteContact] = useState(savedQuote);
  const [emailCaptureActive, setEmailCaptureActive] = useState(false);
  const [enableInitialEmailCapture, setEnableInitialEmailCapture] = useState(accountObj.account.enableInitialEmailCapture);
  const [enableTimeoutEmailCapture, setEnableTimeoutEmailCapture] = useState(accountObj.account.enableTimeoutEmailCapture);
  const [initialEmailCaptureDisplayed, setInitialEmailCaptureDisplayed] = useState(emailCapture.initialEmailCaptureDisplayed || false);
  const [timeoutEmailCaptureDisplayed, setTimeoutEmailCaptureDisplayed] = useState(emailCapture.timeoutEmailCaptureDisplayed || false);
  const [enablePartnerReferralEmailCapture, setEnablePartnerReferralEmailCapture] = useState(emailCapture.enablePartnerReferralEmailCapture || false);
  const [isPartnerReferralEmailCaptureActive, setIsPartnerReferralEmailCaptureActive] = useState(emailCapture.isPartnerReferralEmailCaptureActive || !isQuoteSaved && emailCapture.enablePartnerReferralEmailCapture ? true : false);
  const [modalSaveQuoteIsOpen, setModalSaveQuoteIsOpen] = useState(false);

  const setCurrentSavedQuoteData = () => {
    const newData = getSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA);
    setSaveQuoteContact(newData);
  };

  const handleContactChange = (contact) => {
    setSaveQuoteContact(contact);
  };

  const setTimeoutEmailDisplayed = () => {
    setTimeoutEmailCaptureDisplayed(true);
  };

  const setInitialEmailDisplayed = () => {
    setInitialEmailCaptureDisplayed(true);
  };

  const setEmailPrefill = () => {
    setBasicInfo(basicInfo);
  };

  const onSubmit = () => {
    setEmailCaptureActive(false);
    if (props.aboutMeFormRef.current) {
      props.aboutMeFormRef.current.onSubmit();
    }
  };

  useEffect(() => {
    if (saveQuoteContact.emailAddress !== "") {
      setSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA, {
        "quoteSaved": isQuoteSaved,
        "firstName": saveQuoteContact.firstName,
        "lastName": saveQuoteContact.lastName,
        "emailAddress": saveQuoteContact.emailAddress,
      });
    }
    setCurrentSavedQuoteData();
  }, [isQuoteSaved]);

  return {
    name: 'Supplemental Insurance',
    subtitle: 'Make the Unexpected Easier',
    footerMessage: "Apply for Supplemental Insurance",
    specs: {
      age: { min: minAge, max: maxAge },
    },
    basicInfoForm: () => {
      return <Supplemental 
        landing
        ref={props.aboutMeFormRef}
        setModalSaveQuoteIsOpen={setModalSaveQuoteIsOpen}
        setSaveQuoteData={setSaveQuoteData}
        saveQuoteContact={saveQuoteContact}
        emailCapture={emailCapture}
        setEmailCaptureActive={setEmailCaptureActive}
        emailCaptureActive={emailCaptureActive}
      />;
    },
    about: AboutData(),
    marketing: MarketingData(props.handleSubmitClick),
    purchasingProcess: PurchasingProcessData(),
    saveMyQuotePartnerReferral: <SaveQuotePartnerReferral 
      type="landing-screen"
      title="Almost there!"
      setQuoteSaved={setQuoteSaved}
      isQuoteSaved={isQuoteSaved}
      setEmailPrefill={(e) => setEmailPrefill(e)}
      errorMessage={errorMessage}
      setErrorMessage={setErrorMessage}
      setEmailModal={{
        enableInitialEmailCapture: enableInitialEmailCapture,
        enableTimeoutEmailCapture: enableTimeoutEmailCapture,
        initialEmailCaptureDisplayed: initialEmailCaptureDisplayed,
        timeoutEmailCaptureDisplayed: timeoutEmailCaptureDisplayed,
        isPartnerReferralEmailCaptureActive: isPartnerReferralEmailCaptureActive,
        enablePartnerReferralEmailCapture: enablePartnerReferralEmailCapture,
      }}
      modalSaveQuoteIsOpen={modalSaveQuoteIsOpen}
      setModalSaveQuoteIsOpen={setModalSaveQuoteIsOpen}
      setTimeoutEmailDisplayed={() => setTimeoutEmailDisplayed()}
      setInitialEmailDisplayed={() => setInitialEmailDisplayed()}
      saveQuoteData={saveQuoteData}
      handleContactChange={handleContactChange}
      onSubmit={onSubmit}
    />,
  }
}
